<ng-container *ngIf="vm$ | async as vm">
  <div class="progress-dialog">
    <span class="progress-dialog__text">{{ vm.text }}</span>
    <div class="progress-dialog__animation-container">
      <ng-lottie
        class="progress-dialog__animation"
        [options]="vm.animation"
      ></ng-lottie>
    </div>
  </div>
</ng-container>
